export default "__VITE_ASSET__yl2iSnHyPRVWI2mcEuVpHw__"